import requester from "./requester";

// Performance Plan related requests
const getAllPerformancePlans = (params) => {
  return requester.request.get("/performPlan/listAll", {
    params,
  });
};

const launchPerformancePlan = (data) => {
  return requester.request.post("/performPlan/launch", data);
};

const updatePerformancePlan = (data) => {
  return requester.request.put("/performPlan/update", data);
};

const deletePerformancePlan = (planId) => {
  return requester.request.delete(`/performPlan/delete/${planId}`);
};

const getPerformancePlanUsers = (searchForm) => {
  return requester.request.get("/performPlan/listUsers", {
    params: searchForm,
  });
};

const getPerformancePlanCountByPhase = (planId) => {
  return requester.request.get("/performPlan/countByPhase", {
    params: { planId },
  });
};

const deletePerformancePlanUser = (userId) => {
  return requester.request.delete(`/performPlan/deleteUser/${userId}`);
};

// Performance User related requests
const getPerformUserWithPlanUser = (planId, userId) => {
  return requester.request.get("/performUser/getPerformUserWithPlanUser", {
    params: {
      planId: Number(planId),
      userId: Number(userId),
    },
  });
};

const transferPerformancePlan = (data) => {
  return requester.request.put("/performUser/transfer", data);
};

const rejectPerformancePlan = (data) => {
  return requester.request.put("/performUser/reject", data);
};

const confirmEmployeePerformance = (planId, userId) => {
  return requester.request.put("/performUser/employeeConfirm", {
    planId: Number(planId),
    userId: Number(userId),
  });
};

// Performance Detail related requests
const getPerformanceDetails = (performPlanId, executorId) => {
  return requester.request.get("/performDetail/list", {
    params: {
      performPlanId: Number(performPlanId),
      executorId: Number(executorId),
    },
  });
};

const updateInterviewRecord = (data) => {
  return requester.request.put("/performDetail/interviewRecord", data);
};

const submitPerformanceRating = (voList) => {
  return requester.request.put("/performDetail/rating", voList);
};

// Performance Log related requests
const searchPerformanceLog = (planId, userId) => {
  return requester.request.get("/performLog/searchPerformLog", {
    params: {
      planId,
      userId,
    },
  });
};

// Rule related requests
const getAllRules = () => {
  return requester.request.get("/rule/listAll");
};

const searchRules = (params) => {
  return requester.request.get("/rule/pageSearch", {
    params,
  });
};

const getRuleForEdit = (ruleId) => {
  return requester.request.get("/rule/getForEdit", {
    params: { ruleId },
  });
};

const deleteRule = (ruleId) => {
  return requester.request.get("/rule/deleteRule", {
    params: { ruleId },
  });
};

const addRule = (data) => {
  return requester.request.post("/rule/addRule", data);
};

const updateRule = (data) => {
  return requester.request.post("/rule/update", data);
};

// Dimension related requests
const saveDimension = (data) => {
  return requester.request.post("/dimension/save", data);
};

const listDimensionCategories = (params = {}) => {
  return requester.request.get("/dimensionCategory/list", {
    params,
  });
};

const addDimensionCategory = (data) => {
  return requester.request.post("/dimensionCategory/add", data);
};

const updateDimensionCategory = (data) => {
  return requester.request.put("/dimensionCategory/update", data);
};

// Helper function to get categories by type
const listDimensionCategoriesByType = (categoryType) => {
  return listDimensionCategories({ categoryType });
};

const deleteDimensionCategory = (id) => {
  return requester.request.delete("/dimensionCategory/delete", {
    params: { id },
  });
};

// Training related requests
const getTrainingCompletionStatus = (employeeNumber, yearMonth) => {
  return requester.request.get("/training/completion-status", {
    params: {
      employeeNumber,
      yearMonth,
    },
  });
};

const getMyDingTalkStatisticsSummary = (params) => {
  return requester.request.get("/dingtalk/reports/my-statistics", {
    params,
  });
};

export {
  // Dimension
  addDimensionCategory, addRule, confirmEmployeePerformance, deleteDimensionCategory, deletePerformancePlan, deletePerformancePlanUser, deleteRule,
  // Performance Plan
  getAllPerformancePlans,
  // Rule
  getAllRules,
  // DingTalk report statistics
  getMyDingTalkStatisticsSummary,
  // Performance Detail
  getPerformanceDetails, getPerformancePlanCountByPhase, getPerformancePlanUsers,
  // Performance User
  getPerformUserWithPlanUser, getRuleForEdit,
  // Training
  getTrainingCompletionStatus, launchPerformancePlan, listDimensionCategories, listDimensionCategoriesByType, saveDimension,
  // Performance Log
  rejectPerformancePlan, searchPerformanceLog, searchRules, submitPerformanceRating, transferPerformancePlan, updateDimensionCategory, updateInterviewRecord, updatePerformancePlan, updateRule
};

